<template>
	<v-container>
		<v-overlay :value="spinning"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
		<v-row align="center" justify="center">
			<v-col cols="12" xs="12" sm="7" md="7" lg="7">
				<v-card class="card-rounded elevation-1 mt-3" style="width: 100%; height: auto">
					<div>
						<v-container align="center" justify="center" class="pa-5 pb-0">
							<v-list-item three-line>
								<v-list-item-content>
									<v-list-item-title class="mb-1 text-center"><h1>Verification</h1></v-list-item-title>
									<v-list-item-subtitle class="text-center">We need to verify your details</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-container>

						<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
							<v-form ref="practiceVerificationForm" v-model="valid">
								<v-row
									><v-col>
										<v-select v-model="selectedIndustry" :items="listOfIndustries" label="Select your industry" outlined :rules="industryRules">
										</v-select> </v-col
								></v-row>
								<v-row
									><v-col>
										<v-text-field
											v-model="practiceName"
											:rules="practiceNameRules"
											:label="getLabel('companyName', 'Practice Name')"
											outlined
										></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col> <v-text-field v-model="practiceVatNumber" :rules="practiceVatNumberRules" label="Vat number" outlined></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col>
										<v-text-field
											v-model="practiceRegNumber"
											:rules="practiceRegNumberRules"
											:label="getLabel('companyNumber', 'Practice Number')"
											outlined
										></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col cols="12" class="pb-1">
										<div class="text-subtitle-2 text-start">{{ getLabel('companyContactNumber', 'Practice Contact Number') }}</div>
										<VuePhoneNumberInput
											v-model="phone_number"
											:rules="[v => !!v || 'Mobile number is required']"
											default-country-code="ZA"
											:preferred-countries="['ZA']"
											label="Mobile Number"
											outlined
											required
											size="lg"
											class="mt-0"
											:countries-height="40"
											error-color="red"
											:color="phoneNumberColor"
											@update="onChangeTelNumber"
										/>
									</v-col>
									<v-col cols="12" class="pa-0 mb-5"><span class="float-left ml-6 text-caption red--text">Required</span></v-col>
								</v-row>

								<v-row
									><v-col>
										<v-text-field
											v-model="practiceBussinessEmail"
											:rules="requredRule"
											:label="getLabel('companyEmailAddress', 'Practice Email Address')"
											outlined
										></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col>
										<v-text-field v-model="building" label="Building" hint="Office park, Building, Suite, etc…" persistent-hint outlined></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col> <v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field> </v-col
								></v-row>

								<v-row>
									<v-col>
										<v-select v-model="provinceSelected" outlined :items="province_computed" persistent-hint label="Province" :rules="provinceRules"></v-select>
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<v-select
											v-model="province_region"
											outlined
											:items="region_computed"
											:disabled="provinceSelected ? false : true"
											:label="provinceSelected ? 'City/District/Region' : 'Please select province above.'"
											:rules="regionRules"
										></v-select>
									</v-col>
								</v-row>

								<v-row
									><v-col> <v-text-field v-model="suburb" label="Suburb" outlined :rules="suburbRules"></v-text-field> </v-col
								></v-row>

								<v-row
									><v-col> <v-text-field v-model="postalCode" label="Postal code" :rules="postalCodeRules" outlined></v-text-field> </v-col
								></v-row>
							</v-form>
						</v-card-text>
					</div>
					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container>
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										:disabled="!validForm"
										large
										:loading="loading"
										class="button-rounded continue-signup-button text-none"
										style="text-transform: none !important"
										color="primary"
										@click="SubmitForm()"
										>{{ impersonationMode ? 'Update' : 'Complete sign up' }}<v-icon>mdi-chevron-right</v-icon></v-btn
									>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
/* eslint-disable */
import { bus } from '@/main';
import router from '@/router';
import store from '@/store';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import { provinceRegionPairs, getImpersonationCache, apiPost, apiPut } from '@utils';
import { Tracking } from '@/utils';

export default {
	components: {
		VuePhoneNumberInput,
	},
	props: {
		solo: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			impersonationMode: getImpersonationCache().impersonationMode,
			name: 'practiceVerificationForm',

			valid: false,

			spinning: false,

			loading: false,

			requredRule: [v => !!v || 'Required'],

			practiceNameRules: [v => !!v || 'Required'],

			practiceVatNumberRules: [v => !!v || 'Required'],

			practiceRegNumberRules: [v => !!v || 'Required'],

			practiceContactNumber: null,
			practiceContactNumberRules: [v => !!v || 'Required'],

			phone_number: null,
			phone: null,
			country: null,
			bindProps: {
				mode: 'international',
				placeholder: 'Enter a phone number',
				required: false,
				enabledCountryCode: true,
				enabledFlags: true,
				autocomplete: 'off',
				name: 'telephone',
				maxLen: 25,
				inputOptions: {
					showDialCode: true,
				},
			},

			streetAddressRules: [v => !!v || 'Required'],
			provinceRules: [v => !!v || 'Required'],
			regionRules: [v => !!v || 'Required'],
			profession: null,
			professionRules: [v => !!v || 'Required'],

			suburbRules: [v => !!v || 'Required'],

			industryRules: [v => !!v || 'Required'],

			postalCodeRules: [v => !!v || 'Required'],

			form: false,

			province_regions: provinceRegionPairs,

			practiceName: null,
			practiceVatNumber: null,
			practiceRegNumber: null,
			practiceBussinessEmail: null,
			streetAddress: null,
			provinceSelected: null,
			province_region: null,
			suburb: null,
			postalCode: null,
			building: null,
			selectedIndustry: null,
		};
	},
	computed: {
		industriesConfigsObj() {
			return store.getters.configs.industriesV2;
		},
		listOfIndustries() {
			return Object.keys(this.industriesConfigsObj);
		},
		province_regions_computed() {
			let getpr = store.getters.getProvinceRegions;
			let result = [];
			if (getpr && 'Items' in getpr) {
				getpr.Items.forEach(item => {
					item.subs.forEach(region => {
						result.push({ province: item.name, region: region });
					});
				});
			}
			return result;
		},
		province_computed() {
			let result = [];
			this.province_regions.forEach(set => {
				if (!(set.province in result)) {
					result.push(set.province);
				}
			});
			return result;
		},
		region_computed() {
			let result = [];
			if (this.provinceSelected) {
				this.province_regions.forEach(set => {
					if (this.provinceSelected == set.province) {
						result.push({ text: set.region, value: set, province: set.province, region: set.region });
					}
				});
			}
			return result;
		},
		user() {
			return store.getters.user;
		},
		company() {
			return store.getters.company || {};
		},
		validForm() {
			return this.valid && !!this.practiceContactNumber;
		},
		phoneNumberColor() {
			return !!this.practiceContactNumber ? 'orange' : 'red';
		},
	},
	mounted() {
		Tracking.track('Practice_Verification_Step', {});
		if (this.solo) {
			bus.$on('intent:submit-forms:' + this.name, data => {
				bus.$emit('update:spinning', true);
				this.loading = true;
				this.postToBackend(data);
			});
		} else {
			bus.$on('intent:submit-forms', data => {
				bus.$emit('update:spinning', true);
				this.loading = true;
				this.postToBackend(data);
			});
		}

		const { contact, name, vat_no, practice_number, email, address: { province, region, suburb, street, postal_code, building_name } = {} } = this.company;

		this.phone_number = contact;
		this.practiceName = name;
		this.practiceVatNumber = vat_no;
		this.practiceRegNumber = practice_number;
		this.practiceBussinessEmail = email;
		this.streetAddress = street;
		this.provinceSelected = province;
		this.province_region = {
			province,
			region,
		};
		this.suburb = suburb;
		this.postalCode = postal_code;
		this.selectedIndustry = this.user.profile;
		this.building = building_name;
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
		bus.$off('intent:submit-forms:' + this.name);
	},
	methods: {
		zendeskAssistance() {
			window.zE('webWidget', 'chat:addTags', ['practice', 'verification-step']);
			window.zE('webWidget', 'chat:send', 'Hi, I would like assistance with the verification step.');
			window.zE('webWidget', 'open');
		},
		onChangeTelNumber(data) {
			this.practiceContactNumber = data.formattedNumber;
		},
		countryChanged(country) {
			this.country = '+' + country.dialCode;
		},
		validate() {
			return this.$refs.practiceVerificationForm.validate();
		},
		reset() {
			this.$refs.practiceVerificationForm.reset();
		},
		resetValidation() {
			this.$refs.practiceVerificationForm.resetValidation();
		},
		async postToBackend() {
			let body = {
				name: this.practiceName,
				contact: this.practiceContactNumber,
				email: this.practiceBussinessEmail ? this.practiceBussinessEmail : store.getters.user.email,
				practice_number: this.practiceRegNumber,
				industry: this.selectedIndustry,
				vat_no: this.practiceVatNumber,
				approved: true,
				address: {
					province: this.province_region.province,
					region: this.province_region.region,
					suburb: this.suburb,
					street: this.streetAddress,
					postal_code: this.postalCode,
					building_name: this.building,
				},
			};

			const postData = isCreate => {
				const apiPromise = isCreate ? apiPost('companies', body) : apiPut(`companies/${this.company.id}`, body);
				apiPromise
					.then(response => {
						bus.$emit('form-submitted', { form: this.name, status: response.status });
						if (response.status == 200) {
							store.commit('ADD_COMPANY', response.data.data);
							store.commit('SET_COMPANY_OVERWRITE', response.data.data);
							bus.$emit('navToDashboard');
							router.push('/');
						}
						this.loading = false;
					})
					.finally(() => {
						bus.$emit('update:spinning', false);
						this.spinning = false;
						this.loading = false;
					});
			};

			if (this.impersonationMode) {
				return postData(false);
			}

			Object.assign(body, {
				manager: {
					id: store.getters.user.id,
					name: store.getters.user.name,
					surname: store.getters.user.family_name,
					email: store.getters.user.email,
					contact: store.getters.user.phone_number,
					role: 'PracticeAdmin',
				},
				terms_conditions: true,
			});

			postData(true);
		},
		SubmitForm() {
			let valid = this.validate();
			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			}
		},
	},
};
</script>
